import { createDefaultClosures } from './constants';
import { createEmptyFormErrors } from './formErrors';

// Without '#' — getCSSBackgroundColor adds it when rendering
export const DEFAULT_EVENT_TYPE_COLOR = '6D487B';

export const emptyForm = {
  name: '',
  color: DEFAULT_EVENT_TYPE_COLOR,
  lastValidColor: DEFAULT_EVENT_TYPE_COLOR,
  isVisit: false,
  isSelfScheduled: false,
  showInOwnerReport: false,
  requiredFields: { users: 1, contacts: 0, properties: 0 },
  notifyUsers: { enabled: true, value: 120, unit: 'minutes', by: 'email' },
  notifyContacts: {
    enabled: false,
    items: [{ id: 'contact-1', value: 120, unit: 'minutes', by: 'email' }],
  },
  contactsSubject: '',
  contactsMessage: '',
  requiredReport: true,
  closures: createDefaultClosures(),
  deletedClosureIds: [],
  ownerReportEnabled: false,
  ownerSubject: '',
  ownerMessage: '',
  notifyAgentEnd: false,
  mailAgentEnd: false,
};

const initialState = {
  loading: true,
  error: null,
  generalEvents: [],
  visitEvents: [],
  selectedIds: [],
  filterText: '',
  deleting: false,
  // Create/edit form
  form: {
    ...emptyForm,
    requiredFields: { ...emptyForm.requiredFields },
    notifyUsers: { ...emptyForm.notifyUsers },
    notifyContacts: {
      ...emptyForm.notifyContacts,
      items: emptyForm.notifyContacts.items.map((item) => ({ ...item })),
    },
    closures: createDefaultClosures(),
    errors: createEmptyFormErrors(),
    loading: true,
    saving: false,
    error: null,
    pendingRequestId: null,
  },
};

export default initialState;
